import CHW23Page from "components/pages/CHW23Page";

export default function CaptureQuickTourCards(props) {
    return <CHW23Page />
}